var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1499 20.2508C16.7205 20.2508 17.1988 20.0578 17.5848 19.6718C17.9708 19.2858 18.1638 18.8075 18.1638 18.2369C18.1638 17.6663 17.9708 17.188 17.5848 16.802C17.1988 16.4161 16.7205 16.2231 16.1499 16.2231C15.5793 16.2231 15.1011 16.4161 14.7151 16.802C14.3291 17.188 14.1361 17.6663 14.1361 18.2369C14.1361 18.8075 14.3291 19.2858 14.7151 19.6718C15.1011 20.0578 15.5793 20.2508 16.1499 20.2508ZM8.0945 36.3617V32.3339L20.1777 30.3201V7.91589C20.1777 7.41243 20.0266 6.95931 19.7245 6.55653C19.4225 6.15376 19.0365 5.91881 18.5666 5.85168L8.0945 4.1399V0.112183L19.1707 1.92466C20.6476 2.19317 21.8559 2.88124 22.7957 3.98886C23.7355 5.09649 24.2054 6.38871 24.2054 7.86554V33.643L8.0945 36.3617ZM0.0390625 36.3617V32.3339H4.06678V4.1399C4.06678 2.99872 4.46116 2.04213 5.24993 1.27015C6.03869 0.498172 6.98688 0.112183 8.0945 0.112183H28.2331C29.3743 0.112183 30.3309 0.498172 31.1029 1.27015C31.8748 2.04213 32.2608 2.99872 32.2608 4.1399V32.3339H36.2885V36.3617H0.0390625ZM8.0945 32.3339H28.2331V4.1399H8.0945V32.3339Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpen);
export default __webpack_public_path__ + "static/media/door_open.0a91a573bd826920873567f28a0b81aa.svg";
export { ForwardRef as ReactComponent };